import { InjectionToken } from '@angular/core';

export enum AppLocale {
  en = 'en',
  fr = 'fr',
}

export const APP_LOCALE = new InjectionToken<AppLocale>('APP_LOCALE');
